import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const ILifecycleService = ( createDecorator('lifecycleService'));
function LifecyclePhaseToString(phase) {
    switch (phase) {
        case 1 : return 'Starting';
        case 2 : return 'Ready';
        case 3 : return 'Restored';
        case 4 : return 'Eventually';
    }
}
export { ILifecycleService, LifecyclePhaseToString };
